export default __webpack_public_path__ + "static/media/AFPercentageUpdate.e9ce1b6e.png";